<template>
    <div class="perfect-fit-content-container">
        <div v-for="fit_content in perfect_fit_content" :key="fit_content"> 
            <DynamicImageContainer class="fit-image" :image='"perfect_fit/"+fit_content.image'/>
            <div v-html="fit_content.description"></div>
        </div>
    </div>
</template>
<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
export default {
    components: {DynamicImageContainer},
    props: ['perfect_fit_content'],
}
</script>

<style lang="scss" scoped>
.perfect-fit-content-container{
    display: flex;
    flex-direction: column;
    gap: 25px;
}
.fit-image{
    margin-bottom: 0.32rem;
    width: 100%;
}
</style>